module.exports = __webpack_public_path__ + "img/Group Copy 2.4dc122de.svg";